import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ve" }
const _hoisted_2 = { class: "ve-help" }
const _hoisted_3 = { class: "ve-lane-wrap" }
const _hoisted_4 = { class: "ve-lane" }
const _hoisted_5 = ["id", "aria-pressed", "onClick"]
const _hoisted_6 = { class: "ve-n" }
const _hoisted_7 = {
  key: 0,
  class: "ve-tag"
}
const _hoisted_8 = { class: "ve-t" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "ve-empty"
}
const _hoisted_11 = {
  key: 1,
  class: "ve-s"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 2,
  class: "ve-has"
}
const _hoisted_14 = {
  key: 0,
  viewBox: "0 0 24 24"
}
const _hoisted_15 = {
  key: 1,
  viewBox: "0 0 24 24"
}
const _hoisted_16 = {
  key: 2,
  viewBox: "0 0 24 24"
}
const _hoisted_17 = {
  key: 0,
  class: "ve-arrow",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "ve-dh" }
const _hoisted_19 = { class: "ve-n" }
const _hoisted_20 = { class: "ve-dh-t" }
const _hoisted_21 = {
  key: 0,
  class: "ve-dh-s"
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "ve-img"
}
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = {
  key: 2,
  class: "ve-links"
}
const _hoisted_26 = ["href", "onClick"]
const _hoisted_27 = {
  key: 3,
  class: "ve-none"
}
const _hoisted_28 = {
  key: 2,
  class: "ve-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
        _createElementVNode("path", { d: "M8 13V4.5a1.5 1.5 0 0 1 3 0V12M11 11.5v-2a1.5 1.5 0 0 1 3 0V12M14 10.5a1.5 1.5 0 0 1 3 0V12M17 11.5a1.5 1.5 0 0 1 3 0V16a6 6 0 0 1-6 6h-2 .21a6 6 0 0 1-5-2.69L7 19c-.31-.48-1.4-2.38-3.26-5.7a1.5 1.5 0 0 1 .54-2.02 1.87 1.87 0 0 1 2.28.28L8 13" })
      ], -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.editable ? 'Click a stage to edit it. Stages run left to right.' : 'Click a stage to see what happens there.'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: _ctx.itemKey ? _ctx.itemKey(item) : i
          }, [
            _createElementVNode("button", {
              type: "button",
              id: 've-card-' + i,
              class: _normalizeClass(['ve-card', { on: _ctx.current === item, 've-changed': _ctx.isChanged(i) }]),
              style: _normalizeStyle(_ctx.accent(item)),
              "aria-pressed": _ctx.current === item,
              onClick: ($event: any) => (_ctx.select(i))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(i + 1), 1),
              (_ctx.isChanged(i))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Edited"))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_8, [
                (_ctx.titleLines(item).length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.titleLines(item), (line, j) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                        j
                          ? (_openBlock(), _createElementBlock("br", _hoisted_9))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(line), 1)
                      ], 64))
                    }), 128))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "Untitled stage"))
              ]),
              (_ctx.subLines(item).length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subLines(item), (line, j) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                        j
                          ? (_openBlock(), _createElementBlock("br", _hoisted_12))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(line), 1)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasText(item.description) || item.imageURL || _ctx.hasLinks(item))
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    (_ctx.hasText(item.description))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("title", null, "Has details", -1),
                          _createElementVNode("path", { d: "M4 6h16M4 12h10M4 18h14" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (item.imageURL)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("title", null, "Has an image", -1),
                          _createElementVNode("path", { d: "M15 8h.01M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM3 16l5-5c.93-.9 2.07-.9 3 0l5 5M14 14l1-1c.93-.9 2.07-.9 3 0l3 3" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.hasLinks(item))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("title", null, "Has links", -1),
                          _createElementVNode("path", { d: "M9 15l6-6M11 6l.46-.54a5 5 0 0 1 7.07 7.07L18 13M13 18l-.4.53a5.07 5.07 0 0 1-7.12 0 4.97 4.97 0 0 1 0-7.07L6 11" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 14, _hoisted_5),
            (i < _ctx.items.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                    _createElementVNode("path", { d: "M5 12h14M15 16l4-4-4-4" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _renderSlot(_ctx.$slots, "add")
      ])
    ]),
    (_ctx.editable)
      ? _renderSlot(_ctx.$slots, "editor", { key: 0 })
      : (_ctx.current)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "ve-detail",
            style: _normalizeStyle(_ctx.accent(_ctx.current))
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selectedIndex + 1), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.titleLines(_ctx.current).join(' ') || 'Untitled stage'), 1),
                (_ctx.subLines(_ctx.current).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.subLines(_ctx.current).join(' · ')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.hasText(_ctx.current.description))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ve-body",
                  innerHTML: _ctx.current.description
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true),
            (_ctx.current.imageURL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: _ctx.current.imageURL,
                    alt: 'Image for ' + (_ctx.titleLines(_ctx.current).join(' ') || 'this stage'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-image', _ctx.current.imageURL)))
                  }, null, 8, _hoisted_24)
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasLinks(_ctx.current))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current.linkMenu, (link, j) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: j,
                      class: "ve-chip",
                      href: link.link,
                      target: "_blank",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('open-link', link.link)), ["prevent"])
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                        _createElementVNode("path", { d: "M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M11 13l9-9M15 4h5v5" })
                      ], -1)),
                      _createTextVNode(_toDisplayString(link.label || link.link), 1)
                    ], 8, _hoisted_26))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.hasText(_ctx.current.description) && !_ctx.current.imageURL && !_ctx.hasLinks(_ctx.current))
              ? (_openBlock(), _createElementBlock("p", _hoisted_27, "No details for this stage yet."))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true),
    (!_ctx.items.length && !_ctx.editable)
      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "No stages yet."))
      : _createCommentVNode("", true)
  ]))
}